module.exports = __webpack_public_path__ + "static/img/Fire.498a7e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/elements/Fire.svg
// module id = 1422
// module chunks = 0